import { jwtDecode } from "jwt-decode"
import { useEmployeeContext } from "../context/useMenuEmployeeContext"
import { API_ROUTES } from "../configuration/RoutesApi"

export const useLogout = () => {
  const { handleCloseEmployee } = useEmployeeContext()

  const checkTokenUser = () => {
    var hasToken = localStorage.getItem(API_ROUTES.TOKEN)

    if (hasToken) {
      const userFromToken = jwtDecode(hasToken)

      const tokenExpiration: number = userFromToken.exp!

      const currentTime = Date.now() / 1000

      if (tokenExpiration < currentTime) {
        handleLogOut()
      }
    } else {
      handleCloseEmployee()
    }
  }

  const clearLocalStorage = () => {
    var mail = localStorage.getItem(API_ROUTES.EMAIL_KEY)

    localStorage.clear()

    window.sessionStorage.clear()

    window.localStorage.clear()

    if (mail !== null) {
      localStorage.setItem(API_ROUTES.EMAIL_KEY, mail)
    }
  }

  const handleLogOut = () => {
    clearLocalStorage()

    window.location.reload()
  }

  return {
    checkTokenUser,
    handleLogOut,
  }
}
